import UserActions from "../Types";

const initialState = {
    isGettingTestDetails: false,
    testDetailsSuccess: false,
    testCardPaymentDetails: {},
    isGettingCertDetails: false,
    certDetailsSuccess: false,
    certDetailPaymentDetails: {},
    paymentStatus: false,
    isPaying: false,
    payment: {},
    error: null
}

export default (state = initialState, action) => {
    switch(action.type){
        case UserActions.GET_TESTCARD_PAYMENT_DETAILS_START:
            return {
                ...state,
                isGettingTestDetails: true,
                testDetailsSuccess: false,
                error: null
            }
        case UserActions.GET_TESTCARD_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                isGettingTestDetails: false,
                testDetailsSuccess: true,
                testCardPaymentDetails: action.payload,
                error: null
            }
        case UserActions.GET_TESTCARD_PAYMENT_DETAILS_FAILURE:
            return {
                ...state,
                isGettingTestDetails: false,
                testDetailsSuccess: false,
                error: action.payload
            }
        case UserActions.VERIFY_PAYMENT_START:
            return {
                ...state,
                isVerifying: true,
                paymentStatus: false,
                error: null
            }
        case UserActions.VERIFY_PAYMENT_SUCCESS:
            return {
                ...state,
                isVerifying: false,
                paymentStatus: true,
                payment: action.payload,
                error: null
            }
        case UserActions.VERIFY_PAYMENT_FAILURE:
            return {
                ...state,
                isVerifying: false,
                paymentStatus: false,
                error: action.payload
            }
        case UserActions.GET_CERT_PAYMENT_DETAILS_START:
            return {
                ...state,
                isGettingCertDetails: true,
                certDetailsSuccess: false,
                error: null
            }
        case UserActions.GET_CERT_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                isGettingCertDetails: false,
                certDetailsSuccess: true,
                certDetailPaymentDetails: action.payload,
                error: null
            }
        case UserActions.GET_CERT_PAYMENT_DETAILS_FAILURE:
            return {
                ...state,
                isGettingCertDetails: false,
                certDetailsSuccess: false,
                error: action.payload
            }
        default:
            return state;
    }
}